import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import ConversationMenu from "components/chat/ConversationMenu";
import { fonts } from "fonts";
import { useTheme } from "@emotion/react";
import { useNavigate, useParams } from "react-router-dom";

export default function ConversationList() {

  const params = useParams();
  const conversationId = params.conversationId;

  const navigate = useNavigate();
  const theme = useTheme();
  const conversationsState = useSelector((state) => state.conversations);

  if (conversationsState.error) {
    console.log(conversationsState.error);
    return null;
  }

  const renderConversations = () => {
    const conversations = conversationsState.conversations;
    if (!conversations) return null;
    if (conversations.length === 0) {
      return (
        <ListItem>
          <ListItemText
            sx={{
              color: theme.palette.text.main,
            }}
          >
            No converstions
          </ListItemText>
        </ListItem>
      );
    }
    return conversations.map((conversation, index) => {
      return (
        <ListItem
          key={conversation.id}
          secondaryAction={
            <ConversationMenu
              previousConversation={
                index === 0 ? null : conversations[index - 1]
              }
              nextConversation={
                index + 1 >= conversations.length
                  ? null
                  : conversations[index + 1]
              }
              conversation={conversation}
              color="white"
            />
          }
          sx={{
            borderRadius: "4px",
            backgroundColor:
              conversation.id === conversationId
                ? theme.palette.conversationBackground.active
                : theme.palette.conversationBackground.default,
          }}
        >
          <ListItemButton
            // onClick={() =>
            //   dispatch(botActions.setActiveConversation(conversation))
            // }
            onClick={() => navigate(`/${conversation.id}`)}
          >
            <ListItemText
              sx={{
                color: theme.palette.text.primary,
              }}
              primary={
                <Typography fontFamily={fonts.geist}>
                  {conversation.subject}
                </Typography>
              }
              secondary={
                <Typography fontFamily={fonts.geist} variant="caption">
                  {new Date(conversation.createdAt).toLocaleString()}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      );
    });
  };

  return (
    <List dense disablePadding>
      {conversationsState.loading ? (
        <>
          {Array.from(Array(3)).map((x, index) => (
            <ListItem key={`conversation-skeleton-${index}`}>
              <ListItemText
                primary={<Skeleton variant="text" />}
                secondary={<Skeleton variant="text" />}
              />
            </ListItem>
          ))}
        </>
      ) : (
        renderConversations()
      )}
    </List>
  );
}
